<template>
  <div>
    <router-view />
  </div>
</template>

<script>
export default {
  name: "MobileLayout",
};

</script>

<style>
</style>
